import { useEffect, useState } from "react";
import {
  deleteResultById,
  downloadPdf,
  getPdfUrl,
  getTestResults,
} from "../../shared/api/results";
import formatDate from "./helpers/formatDate";
import { Pagination } from "./components/Pagination";
import sendEmail from "../../helpers/sendEmail";
import { Toast } from "../../components/Toast/Toast";

// const sendInfo = {
//   serviceId: "service_z0lmq6h",
//   templateId: "template_8mrolh1",
//   publicKey: "f0XtLro7aLnWYVrrl",
// };

export const sendInfo = {
  serviceId: "service_4y96hpa",
  templateId: "template_yglprp9",
  publicKey: "PLZxxqqA7zYEr1YHg",
};

export default function TestResultsPage() {
  const [results, setResults] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [toast, setToast] = useState({ message: "", type: "" });

  const [search, setSearch] = useState("");
  const [testName, setTestName] = useState("");
  const [dateTaken, setDateTaken] = useState("");

  const totalPages = Math.ceil(count / 10);

  const fetchResults = async (params = {}) => {
    setLoading(true);
    try {
      const data = await getTestResults(params);
      setResults(data.results);
      setCount(data.count);
      setCurrentPage(params.page || 1);
      setError("");
    } catch (e) {
      setError("Ошибка загрузки результатов");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    fetchResults({
      page: 1,
      search,
      test_name: testName,
      date_taken: dateTaken,
    });
  };

  useEffect(() => {
    fetchResults();
  }, []);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
  };

  const handleToastClose = () => {
    setToast({ message: "", type: "" });
  };

  const handleDownload = (fullname, test, id) => {
    
    downloadPdf(fullname, test, id);
  };

  const handleSend = async (result) => {
    const pdfUrl = getPdfUrl(result.id);
    const { test_name, full_name, score } = result;
    try {
      const directusSendInfo = {
        provider: "directus_flow",
        baseUrl: "https://crm-hr.kzn.ru",
        flowId: "9c0df71d-3ceb-4ab4-aa0c-a6806f3d89a6",
        token: "sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM",
        subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || "HR Tests",
      };
      await sendEmail(undefined, test_name, full_name, score, pdfUrl, directusSendInfo);
      showToast(`Результат ${full_name} успешно отправлен`);
    } catch {
      showToast("Ошибка при отправке результата на почту", "error");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Вы уверены, что хотите удалить этот результат?")) {
      const success = await deleteResultById(id);
      if (success) {
        setResults((prevResults) =>
          prevResults.filter((result) => result.id !== id)
        );
        setCount((prevCount) => prevCount - 1);
      } else {
        alert("Ошибка удаления результата");
      }
    }
  };
  const handlePageChange = (page) => {
    fetchResults({ page, search, test_name: testName, date_taken: dateTaken });
  };

  if (loading)
    return (
      <div className="w-full h-[100dvh] flex justify-center items-center">
        <h1>Загрузка...</h1>
      </div>
    );

  if (error) return <div className="text-red-500 text-center">{error}</div>;

  return (
    <div className="w-full mt-2 sm:max-w-7xl mx-auto p-6 bg-white rounded-lg shadow">
      <Toast
        message={toast.message}
        type={toast.type}
        onClose={handleToastClose}
        duration={3000}
      />
      <h1 className="text-2xl font-semibold mb-6 text-center">
        Результаты тестирования
      </h1>

      <div className="mb-6">
        <form
          className="flex flex-wrap md:flex-nowrap justify-between gap-2 text-sm "
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col sm:flex-row w-full gap-2">
            <input
              type="text"
              placeholder="Поиск по ФИО"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="p-2 border border-blue-300 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <input
              type="text"
              placeholder="Тип теста"
              value={testName}
              onChange={(e) => setTestName(e.target.value)}
              className="p-2 border border-blue-300 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
            <input
              type="date"
              value={dateTaken}
              onChange={(e) => setDateTaken(e.target.value)}
              className="p-2 border border-blue-300 rounded-md w-full sm:w-1/3 focus:outline-none focus:ring-2 focus:ring-blue-300"
            />
          </div>
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md transition shadow-sm w-full sm:w-auto"
          >
            Применить
          </button>
        </form>
      </div>

      <h2 className="text-lg font-semibold mb-4">
        История результатов тестирования
      </h2>
      <div className="overflow-x-auto rounded-xl border border-blue-300">
        <table className="min-w-[1000px] w-full border-separate border-spacing-0 text-[16px]">
          <thead>
            <tr className="bg-blue-200 ">
              <th className="p-3 border-b border-r border-blue-300 text-left">
                Действие
              </th>
              <th className="p-3 border-b border-r border-blue-300 text-left">
                Дата
              </th>
              <th className="p-3 border-b border-r border-blue-300 text-left">
                ФИО
              </th>
              <th className="p-3 border-b border-r border-blue-300 text-left max-w-[200px] break-words">
                Тип теста
              </th>
              <th className="p-3 border-b border-r border-blue-300 text-left">
                Результаты
              </th>
              <th className="p-3 border-b border-blue-300 text-left">
                Скачать
              </th>
            </tr>
          </thead>
          <tbody>
            {results.length === 0 ? (
              <tr>
                <td colSpan="5" className="p-4 text-center">
                  Результаты отсутствуют.
                </td>
              </tr>
            ) : (
              results.map((res, idx) => (
                <tr
                  key={res.id}
                  className={`${idx % 2 === 0 ? "bg-white" : "bg-blue-50"} `}
                >
                  <td className=" border-t border-r text-center w-[1rem] p-3 max-w-[500px] border-blue-300">
                    <button
                      onClick={() => handleDelete(res.id)}
                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded transition"
                    >
                      Удалить
                    </button>
                  </td>
                  <td className="p-3 border-t border-r border-blue-300">
                    {formatDate(res.date_taken) || "—"}
                  </td>
                  <td className="p-3 border-t border-r border-blue-300">
                    {res.full_name || "—"}
                  </td>
                  <td className="p-3 border-t border-r border-blue-300 max-w-[200px] break-words">
                    {res.test_name || "—"}
                  </td>
                  <td className="p-3 border-t border-r border-blue-300  whitespace-pre-line">
                    {res.score || "-"}
                  </td>
                  <td className="p-3 border-t border-blue-300 text-center">
                    {res.pdf && (
                      <button
                        onClick={() => handleDownload(res.full_name,  res.test_name,  res.id)}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition"
                      >
                        Скачать
                      </button>
                    )}
                    <button
                      onClick={() => handleSend(res)}
                      className="bg-green-600 hover:bg-green-700 text-white text-center px-3 py-1 rounded transition mt-2"
                    >
                      Отправить на почту
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="flex justify-center items-center mt-4 text-sm">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
